/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ArchivedReportFlowContainerLocal = {
    readonly dsaFeaturesEnabled: boolean | null;
    readonly " $refType": "ArchivedReportFlowContainerLocal";
};
export type ArchivedReportFlowContainerLocal$data = ArchivedReportFlowContainerLocal;
export type ArchivedReportFlowContainerLocal$key = {
    readonly " $data"?: ArchivedReportFlowContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ArchivedReportFlowContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivedReportFlowContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dsaFeaturesEnabled",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '34df845b1e8c0fe8c53fbe2efc53fdad';
export default node;
